import React from 'react';
import { Button } from '@kajabi/sage-react';

import { useCheckout } from '../../context';

export const SubmitButton = () => {
  const {
    planInfo: { cta_button_text: text },
    submitForm,
    submitFormTwoStepFirstStep,
    submittingForm,
    isTwoStepsSignupFirstStep,
    isTwoStepsSignupSecondStep,
  } = useCheckout();

  return (
    <>
      {
        submittingForm && isTwoStepsSignupSecondStep()
          ? <p>Please do not refresh the page...</p>
          : null
      }
      <Button
        disabled={submittingForm}
        fullWidth
        onClick={
          isTwoStepsSignupFirstStep() ? submitFormTwoStepFirstStep : submitForm
        }
      >
        { isTwoStepsSignupFirstStep() ? 'Continue' : text}
      </Button>
    </>
  );
};
